import { render, staticRenderFns } from "./FailureRanking.vue?vue&type=template&id=2d697548&scoped=true"
import script from "./FailureRanking.vue?vue&type=script&lang=js"
export * from "./FailureRanking.vue?vue&type=script&lang=js"
import style0 from "./FailureRanking.vue?vue&type=style&index=0&id=2d697548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d697548",
  null
  
)

export default component.exports